import { useState } from "react";
import { IonContent, IonPage, useIonRouter } from "@ionic/react";
import "./GetHelp.css";
import { client } from "../../api/client";
import { DEFAULT_HOME_PATH } from "../../utils/constents";

const GetHelp = () => {
  // State variables remain the same to preserve logic
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [category, setCategory] = useState("");
  const [error, setError] = useState(null);
  const router = useIonRouter();
  const helpTopics = [
    { icon: "🔑", label: "Reset password" },
    { icon: "✉️", label: "Verify email" },
    { icon: "🗑️", label: "Delete post" },
    { icon: "🚩", label: "Community rules" },
    { icon: "🏴", label: "Report abuse" },
    { icon: "⚠️", label: "Account Issue" },
  ];
  const categories = [
    "🔐 Account & Login",
    "🛒 Marketplace",
    "👥 Communities",
    "🎥 LoonClips",
    "📰 Canada Now",
    "📱 App Bug",
    "🚨 Report User",
    "❓ Other",
  ];
  const sendHelpRequest = async () => {
    setIsSubmitting(true);
    setError(null);

    try {
      await client.post("/report/create-request", {
        category,
        title: subject,
        description,
      });
      router.push(DEFAULT_HOME_PATH, "root");
      return true;
    } catch (err) {
      const message = err.message || "We couldn't send your message.";
      setError({ message });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await sendHelpRequest();
    if (success) {
      setSubject("");
      setDescription("");
    }
  };
  // --- INSERT 1: Add Logic inside component ---
  const handleTopicClick = (topic) => {
    setSubject(topic); // Auto-fills the subject line
  };
  return (
    <IonPage>
      <IonContent fullscreen style={{ "--background": "#f8f9fa" }}>
        {/* New Wrapper Class for the new theme */}
        <div className="support-center-page">
          <header className="support-header">
            <button
              className="nav-back-btn"
              aria-label="Return to previous page"
              onClick={() => router.goBack()}
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 18l-6-6 6-6" />
              </svg>
              <span>Back</span>
            </button>
          </header>

          <div className="content-container">
            <div className="title-section">
              <h1 className="main-heading">Support Center</h1>
              <p className="sub-heading">
                Need help, felow Loon? The <b>LoonLog</b> team has your back. 🇨🇦
                We're here to help.
              </p>
            </div>
            {/* --- INSERT 2: The New Section --- */}
            <div className="popular-topics-wrapper">
              <h3 className="section-label">Popular Help Topics</h3>
              <div className="topics-grid">
                {helpTopics.map((topic, index) => (
                  <button
                    className="topic-btn"
                    onClick={() => handleTopicClick(topic.label)}
                  >
                    <span className="topic-icon">{topic.icon}</span>
                    <span className="topic-text">{topic.label}</span>
                  </button>
                ))}
              </div>
            </div>
            <form onSubmit={handleSubmit} className="modern-form">
              {/* Category Dropdown */}
              <div className="input-group">
                <label htmlFor="category" className="modern-label">
                  Category <span style={{ color: "#ef4444" }}>*</span>
                </label>
                <div className="select-wrapper">
                  <select
                    id="category"
                    className="modern-input"
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                    required
                  >
                    <option value="" disabled>
                      Select a category
                    </option>
                    {categories.map((cat) => (
                      <option key={cat} value={cat}>
                        {cat}
                      </option>
                    ))}
                  </select>
                  <div className="select-chevron">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#6b7280"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="input-group">
                <label htmlFor="subject" className="modern-label">
                  Topic
                </label>
                <input
                  type="text"
                  id="subject"
                  className="modern-input"
                  placeholder="e.g. Login trouble, Report a bug"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </div>

              <div className="input-group">
                <label htmlFor="description" className="modern-label">
                  How can we help?
                </label>
                <textarea
                  id="description"
                  className="modern-textarea"
                  placeholder="Tell us a bit more about what is happening..."
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                ></textarea>
              </div>

              {error && (
                <div className="alert-box">
                  <span className="alert-icon">!</span>
                  <span>{error.message}</span>
                </div>
              )}

              <button
                type="submit"
                className="action-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <span className="loading-dots">Sending...</span>
                ) : (
                  "Send Message"
                )}
              </button>
            </form>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default GetHelp;
